import React, { ReactElement } from 'react';

import { EntityContext } from 'context/entityContext';
import DiscoveryKPIs from 'components/data-containers/KPIs/Discovery/DiscoveryKPIs';
import DiscoveryPerformanceTrend from 'components/data-containers/PerformanceTrend/DiscoveryPerformanceTrend';
import Layout from 'components/styled/Layout/Layout';
import Message from 'components/base/Message/Message';
import pluralize from 'helpers/pluralize';
import ShazamTagSkeletonLoader from 'components/data-containers/ShazamTag/SkeletonLoader';

const ShazamTag = React.lazy(() =>
  import('components/data-containers/ShazamTag/ShazamTag')
);

function Discovery(): ReactElement<any, any> {
  const ctx = React.useContext(EntityContext);
  const { compareMode, entityType } = ctx;

  return (
    // Note: Do not remove the next <div>. It avoids flexbox to double margins between generic components.
    <div>
      <DiscoveryKPIs {...ctx} />

      <DiscoveryPerformanceTrend />

      {!compareMode && (
        <React.Suspense fallback={<ShazamTagSkeletonLoader />}>
          <ShazamTag />
        </React.Suspense>
      )}

      {compareMode && (
        <Layout.MaxWidth>
          <Message>
            Shazam tags is not available in compare{' '}
            {pluralize(compareMode === 'country' ? compareMode : entityType)}{' '}
            mode. Exit compare mode to see Shazam tags for this {entityType}.
          </Message>
        </Layout.MaxWidth>
      )}
    </div>
  );
}

export default Discovery;
